import React, { useState, useMemo } from 'react'
import { Link } from 'react-router-dom'
import { Swiper, SwiperSlide } from 'swiper/react';
import FsLightbox from 'fslightbox-react';
import SwiperCore, { Navigation } from 'swiper/core';
import { useContent } from '../../services'

SwiperCore.use([Navigation]);

const galleryImages = {
    'gallery-1.jpg': require('../../assets/images/resource/gallery-1.jpg'),
    'gallery-2.jpg': require('../../assets/images/resource/gallery-2.jpg'),
    'gallery-3.jpg': require('../../assets/images/resource/gallery-3.jpg'),
};

function Sliderabout() {
    const { data, loading } = useContent('aboutContent');

    const options = {
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    }

    const [toggler, setToggler] = useState(false);
    const [activeImage, setActiveImage] = useState(1);

    // Build slides array: repeat gallery images twice for carousel effect
    const slides = useMemo(() => {
        if (!data) return [];
        const imgs = data.gallery.images;
        return [...imgs, ...imgs].map((img, i) => ({
            id: i + 1,
            src: galleryImages[img],
        }));
    }, [data]);

    const lightboxSources = useMemo(() => slides.map(s => s.src), [slides]);

    if (loading || !data) return null;

    return (
        <>
            <section className="image-gallery">
                <div className="carousel-box">
                    <Swiper {...options} loop={true} slidesPerView={1.5} centeredSlides={true} spaceBetween={30}
                        grabCursor={true} modules={[]} className="mySwiper">
                        {slides.map((slide, idx) => (
                            <SwiperSlide key={slide.id} className={idx === 0 ? 'gallery-block' : 'gallery-block item'}>
                                <div className="image">
                                    <Link to="#" onClick={(e) => e.preventDefault()} className="lightbox-image" data-fancybox="gallery">
                                        <figure className="gallery-image" onClick={() => {
                                            setToggler(!toggler)
                                            setActiveImage(slide.id)
                                        }}>
                                            <img src={slide.src} alt="" />
                                        </figure>
                                    </Link>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </section>
            <FsLightbox toggler={toggler} sources={lightboxSources} slide={activeImage} />
        </>
    );
}

export default Sliderabout
